<template>
  <div class="base-control base-date form-group" :class="{row: inline, 'error': hasErrors, 'ok': isOk, disabled: disabled }">
    <label v-if="label" :for="id" class="col-sm-4" :class="{'col-form-label': inline}">{{ label }}</label>
    <div class="col-sm-8" :class="{'position-relative': inline}">
      <input ref="input" :id="id" class="form-control simple datetimepicker" :disabled="disabled"
             :class="{[radius]: true, 'is-invalid': hasErrors}" :readonly="readonly"
             :type="type" :value="value" @input="onInput($event)" :placeholder="placeholder" />

      <div class="invalid-feedback" :class="{'absolute-right-errors': (hasErrors && inline)}" v-if="err && err.length > 0">
        <p class="error mb-0" v-for="error in err" :key="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>

  import jquery from 'jquery';
  // eslint-disable-next-line
  import datetimepicker from 'bootstrap4-datetimepicker';

  jquery.fn.datetimepicker.defaults.icons = {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-left',
    next: 'fa fa-chevron-right',
    today: 'fa fa-dot-circle-o',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
  };

  export default {
    name: 'BaseDate',
    inject: ['$validator'],
    props: {
      value: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      err: {
        type: Array,
        default: () => []
      },
      radius: {
        type: String,
        default: ''
      },
      inline: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String,
        default: ''
      },
      format: {
        type: String,
        default: 'D / M / YYYY'
      },
      monthOnly: {
        type: Boolean,
        default: false,
      }
    },
    $_veeValidate: {
      value () {
        return this.$refs.input.value;
      },
      name () {
        return this.name;
      }
    },
    methods: {
      onInput (event) {
        this.$emit('input', event.target.value);
        // this.$emit('input', '');
      }
    },
    data () {
      return {
        date: null,
      };
    },
    mounted () {
      if (this.value !== null && this.value !== '') {
        this.$validator.validateAll();
      }

      var self = this;

      jquery(this.$refs.input).datetimepicker({
        format: this.monthOnly ? 'M-YYYY' : this.format,
        ignoreReadonly: true,
        // allowInputToggle: true
        // inline: true,
      }).on('dp.change', (e) => {
        const { value } = e.currentTarget;
        self.$emit('input', value);
      });
    },
    computed: {
      id () {
        return 'base-date-' + this._uid;
      },
      hasErrors () {
        return this.err && this.err.length > 0;
      },
      isOk() {
        let k = '';
        for (const key in this.fields) {
          k = key;
        }

        if (!this.fields[k] || !this.fields[k][this.name]) return false;
        return this.fields[k][this.name].validated && this.fields[k][this.name].valid;
      }
    },
    beforeDestroy: function () {
      jquery(this.$refs.input).find('.datetimepicker').datetimepicker('destroy');
    }
  };

</script>

<style lang="scss">

  $headerHeight: 30px;
  .bootstrap-datetimepicker-widget table th {
    height: $headerHeight;
    line-height: $headerHeight;
  }

  .select-green .vs__dropdown-toggle {
    background-color: lightgreen!important;
  }
</style>
